import { bindable, BindingMode, capture } from "aurelia";

@capture((attrs) => attrs !== "id" && attrs !== "label" && attrs !== "disabled" && attrs !== "validate")
export class InputCountComponent {
  public id: string = crypto.randomUUID();
  @bindable disabled: boolean = true

  @bindable label: string;

  @bindable({ mode: BindingMode.twoWay }) valueInput: number

  @bindable public validate: boolean = false

  blockArrowKeys(event: KeyboardEvent) {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
    }
  }

  decrementPanel() {
    if (this.valueInput <= 0) return

    let handleValue = Number(this.valueInput)

    this.valueInput = handleValue -= 1
  }

  incrementPanel() {
    if (!this.valueInput) this.valueInput = 0

    let handleValue = Number(this.valueInput)

    this.valueInput = handleValue += 1
  }
}